import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { PhysiologicalDataApi } from '../../../apis/PhysiologicalDataApi/PhysiologicalDataApi';
import { IPhysiologicalData, physiologicalData } from '../PhysiologicalData';

export function useGetphysiologicalData(patientId?: string) {
    return useQuery({
        queryKey: [QueryKeys.physiologicalData],
        queryFn: async () => {
            const results: IPhysiologicalData[] = await PhysiologicalDataApi.getPhysiologicalDatas(patientId!);
            return results
                .map((result) => new physiologicalData(result))
                .sort((a, b) => new Date(a.dateMeasured).getTime() - new Date(b.dateMeasured).getTime());
        },
        enabled: !!patientId,
    });
}
